import { getData, postData } from './request';
import type {
  OrderFeatureKey,
  OrderFeatures,
  OrderFeatureState,
} from '@cutr/constants/order-features';

export function getOrderFeatures(orderId: string, signal?: AbortSignal) {
  return getData<OrderFeatures>(`/v2/orders/${orderId}/features`, { signal });
}

export function setOrderFeature(
  orderId: string,
  featureKey: OrderFeatureKey,
  payload: { enabled: boolean; clearExisting?: boolean }
) {
  return postData<OrderFeatureState>(
    `/v2/orders/${orderId}/features/${featureKey}`,
    payload
  );
}
